import MuiDatePicker from "@mui/lab/DatePicker";
import { TextField } from "@mui/material";

const InlinePicker = (props) => {
  const { label, date, format, onChange } = props;

  return (
    <MuiDatePicker
      label={label}
      value={date}
      inputFormat={format}
      disableMaskedInput={true}
      onChange={(date) => onChange(date)}
      renderInput={(params) => <TextField {...params} variant="standard" />}
    />
  );
};

export default InlinePicker;
